import React, { useState,useEffect} from "react";
import styled from "styled-components";
import Button from '@mui/material/Button';
import {Link} from "react-router-dom";


const LayoutBox = styled.div`
    width:100%;
    display:flex;
    justift-contents:flex-start;
    flex-direction: column;
    margin-left:20px;
    margin-top:30px;
`;
const AirportListBox = styled.div`
    display:flex;
    justift-contents:flex-start;
    flex-direction: column;
    margin-top:10px;
    margin-left:1px;
    flex-wrap:wrap;
    gap: 20px;
    width:50%;
    height:72vh;
`;


const SearchBoxDiv=styled.div`
    display: flex;
    flex:1;
    color:black;
    justify-content: space-between;
    align-items: center;
    padding-left: 0rem;
    list-style: none;
    height: 40px;
    text-decoration: none;
    font-size: 18px;
    
    width:50%;
`;
const AirportSelector=({setTitle,pageTitle,setActiveAirport,setActiveMetric,airportDataList,enabledAirports,activeMetric})=>{

  useEffect(() => {
    setTitle(pageTitle=>'')
    },[airportDataList]);
  const [displayAirportList, setDisplayAirportList] = useState([]);
  const [displayAirportCityList, setDisplayAirportCityList] = useState([]);
  useEffect(()=>{
    var disableRefList = Array.from(Array(Object.keys(airportDataList).length).keys())
    if(Object.hasOwn(enabledAirports,activeMetric)){
        var orderRef = disableRefList.map(
                            (ref,index)=> enabledAirports[activeMetric].includes(
                                    Object.keys(airportDataList)[index])?-1:ref)
        console.log(orderRef.keys())
        var indices = Array.from(orderRef.keys()).sort( (a,b) => orderRef[a]- orderRef[b]);

        var sortedAirportList = indices.map(i => Object.keys(airportDataList)[i])
        var sortedAirportCityList = indices.map(i => Object.keys(airportDataList).map((airport) =>airportDataList[airport]['city'])[i])
        setDisplayAirportList(sortedAirportList);
        setDisplayAirportCityList(sortedAirportCityList);
    }else{
      setDisplayAirportList(Object.keys(airportDataList))
      setDisplayAirportCityList(Object.keys(airportDataList).map((airport) =>airportDataList[airport]['city']))
    }
    setActiveMetric(activeMetric);
  },[activeMetric,airportDataList]);
  
    const buttonStyle = {textAlign:'left',textDecoration:'none',fontSize:'0.8em',display:'flex',justifyContents:'flex-start',
                         minHeight:'36px',maxHeight:'36px',maxWidth:'200px',minWidth:'56px',
                         paddingRight:'0px',paddingLeft:'0px',paddingTop:'6px',paddingBottom:'0px'}
    function updateDisplayAirportList(e){
         if(e.target.value.trim() !=''){
         setDisplayAirportList(Object.keys(airportDataList).filter((airport) => {
             return ((airport.toUpperCase().startsWith(e.target.value.trim().toUpperCase()))||
                    (airportDataList[airport]['city'].toUpperCase().startsWith(e.target.value.trim().toUpperCase())))
             }))
         setDisplayAirportCityList(Object.keys(airportDataList).filter((airport) => {
             return ((airport.toUpperCase().startsWith(e.target.value.trim().toUpperCase()))||
                    (airportDataList[airport]['city'].toUpperCase().startsWith(e.target.value.trim().toUpperCase())))
                        
             }).map((airport) => airportDataList[airport]['city']))
             
         }
         else{
             setDisplayAirportList(Object.keys(airportDataList))
             setDisplayAirportCityList(Object.keys(airportDataList).map((airport) => airportDataList[airport]['city']))
         };
    }
  return(
    <LayoutBox>
    <SearchBoxDiv>
      <input name="airportName" style={{width:'100%'}} defaultValue={""} onChange={updateDisplayAirportList}>
      </input>
    </SearchBoxDiv>
    <AirportListBox>
        {displayAirportList.map((airport,index) => {
                            return(
                                <div style={{display:'flex',justifyContents:'flex-start'}}>
                                <Button style={buttonStyle} variant="text" color="primary" component={Link} 
                                    to={"/metrics/"+activeMetric+"/"+airport}
                                    onClick={()=>{setActiveAirport(airport)}}
                                    disabled={!Object.hasOwn(enabledAirports,activeMetric)||(Object.hasOwn(enabledAirports,activeMetric)&&enabledAirports[activeMetric].includes(airport))?false:true}
                                    >
                                    {airport+', '+displayAirportCityList[index]}
                                </Button>
                                </div>
                            );
                        })}
    </AirportListBox>    
    </LayoutBox>
  );
};
export default AirportSelector;
